<template>
  <a-modal
    :title="modalTitle"
    :maskClosable="false"
    :visible="showModal"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
    @ok="handleOk"
    okText="提交"
  >
    <a-form layout="horizontal" :form="form">
      <!-- 用户名 -->
      <a-form-item
        label="用户名"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-input
          placeholder="请输入用户名"
          v-decorator="[
            'userName',
            {
              rules: [
                { required: true, message: '请输入用户名' },
                {
                  pattern: /^[0-9a-zA-Z]+$/,
                  message: '用户名只能为字母和数字'
                }
              ]
            }
          ]"
        />
      </a-form-item>
      <!-- 密码 -->
      <a-form-item
        label="密码"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-input
          :placeholder="passwordPlaceholder"
          type="password"
          v-decorator="[
            'password',
            {
              rules: [{ validator: validatorPassword }]
            }
          ]"
        />
      </a-form-item>
      <!-- 企业 -->
      <a-form-item
        label="企业"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-select
          v-decorator="[
            'enterpriseId',
            {
              rules: [{ required: true, message: '请选择企业' }]
            }
          ]"
          placeholder="请选择企业"
        >
          <a-select-option
            v-for="item in enterpriseList"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <!-- 手机号 -->
      <a-form-item
        label="手机号"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-input
          placeholder="请输入手机号"
          v-decorator="[
            'userPhone',
            {
              rules: [
                { required: true, message: '请输入手机号' },
                {
                  pattern: /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/,
                  message: '联系电话格式不正确'
                }
              ]
            }
          ]"
        />
      </a-form-item>
      <!-- 邮箱 -->
      <a-form-item
        label="邮箱"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-input
          placeholder="请输入邮箱"
          v-decorator="[
            'email',
            {
              rules: [{ validator: validatorEmail }]
            }
          ]"
        />
      </a-form-item>
      <!-- id -->
      <a-form-item v-if="addInfo.id">
        <a-input type="hidden" v-decorator="['id', { rules: [] }]"></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>

import { getEnterpriseDropdownList } from '@/apis/enterprise'
export default {
  data () {
    return {
      modalTitle: '添加用户',
      enterpriseList: [],
      passwordPlaceholder: '请输入密码'
    }
  },
  props: {
    submitType: {
      type: String,
      default: 'add'
    },
    showModal: {
      type: Boolean,
      default: false
    },
    confirmLoading: {
      type: Boolean,
      default: false
    },
    addInfo: {
      type: Object,
      default: () => {
        return {
          userName: '',
          password: '',
          phone: '',
          email: ''
        }
      }
    }
  },
  methods: {
    handleCancel () {
      this.form.resetFields()
      this.$emit('cancel')
    },
    handleOk (e) {
      this.$emit('submit', this.form)
    },
    validatorEmail (rule, value, callback) {
      if (value && !/^[a-z0-9+.]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(value)) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('邮箱格式不正确')
      } else {
        callback()
      }
    },
    validatorPassword (rule, value, callback) {
      const check = () => {
        if (value.length < 6) {
          // eslint-disable-next-line standard/no-callback-literal
          callback('密码不能小于6位')
        }
        if (value.length > 20) {
          // eslint-disable-next-line standard/no-callback-literal
          callback('密码不能大于20位')
        }
        callback()
      }

      if (this.submitType === 'add') {
        if (!value) {
          // eslint-disable-next-line standard/no-callback-literal
          callback('请输入密码')
        } else {
          check()
        }
      } else {
        if (value) {
          check()
        } else {
          callback()
        }
      }
    },
    // 获取企业下拉
    _getEnterpriseDropdownList () {
      getEnterpriseDropdownList().then(res => {
        this.enterpriseList = res.data.attribute
      })
    }
  },
  created () {
    this._getEnterpriseDropdownList()
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  watch: {
    addInfo: function (data) {
      setTimeout(() => {
        this.form.setFieldsValue(this.addInfo)
      }, 100)
    },
    submitType: function (data) {
      this.modalTitle = data === 'add' ? '添加用户' : '修改用户'
      this.passwordPlaceholder = data === 'add' ? '请输入密码' : '密码为空则默认不修改'
    }
  }

}
</script>

<style lang="less" scoped></style>
